class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    if (!this.notification) return;

    this.notification.inert = true; // keep closed dialog non-focusable (recommended)
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Track opener so focus can return safely on close
    const cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      cartLink.addEventListener('click', () => this.setActiveElement(cartLink));
      cartLink.addEventListener('keydown', (e) => {
        const code = (e.code || '').toUpperCase();

        // Only prevent Space (it scrolls the page). Do NOT prevent Enter on a link.
        if (code === 'SPACE') e.preventDefault();

        if (code === 'ENTER' || code === 'SPACE') {
          this.setActiveElement(cartLink);
        }
      });
    }

    this.notification.addEventListener('keydown', (evt) => {
      const code = (evt.code || '').toUpperCase();
      if (code === 'ESCAPE') {
        evt.preventDefault();
        this.close();
      }
    });
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Ensure "Continue shopping" closes (in case theme swaps DOM)
    const continueBtn = this.querySelector('.cart-notification__links .button-label');
    continueBtn?.addEventListener('click', this.close.bind(this));
  }

  open() {
    if (!this.notification) return;
    this.notification.classList.add('animate', 'active');

    // A11y: expose as modal only while open
    this.notification.inert = false;
    this.notification.removeAttribute('aria-hidden');
    this.notification.setAttribute('aria-modal', 'true');

    const onOpenReady = () => {
      this.notification.focus();
      trapFocus(this.notification);
    };

    this.notification.addEventListener('transitionend', onOpenReady, { once: true });

    // Fallback: if there's no transition, run on next frame
    requestAnimationFrame(() => {
      const isActive = this.notification.classList.contains('active');
      const styles = window.getComputedStyle(this.notification);
      const dur = parseFloat(styles.transitionDuration) || 0;

      if (isActive && dur === 0) onOpenReady();
    });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');

    // A11y: hide from AT when closed
    this.notification.setAttribute('aria-hidden', 'true');
    this.notification.removeAttribute('aria-modal');
    this.notification.inert = true;

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement || document.getElementById('cart-icon-bubble'));
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
